import { render, staticRenderFns } from "./ReprogramarEnvios.vue?vue&type=template&id=2f81054b&scoped=true&"
import script from "./ReprogramarEnvios.vue?vue&type=script&lang=js&"
export * from "./ReprogramarEnvios.vue?vue&type=script&lang=js&"
import style0 from "./ReprogramarEnvios.vue?vue&type=style&index=0&id=2f81054b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f81054b",
  null
  
)

export default component.exports